import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import { KnovasMark } from "./KnovasLogo";

export default function Navbar() {
  const location = useLocation();
  const isCover = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!isCover) return;
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isCover]);

  const transparent = isCover && !scrolled;
  const linkBase = "text-xs uppercase tracking-[0.25em] font-medium transition-colors";
  const linkClass = ({ isActive }) =>
    `${linkBase} ${isActive ? "text-[#FF6A00]" : transparent ? "text-white/80 hover:text-white" : "text-[#2B2B2B] hover:text-[#FF6A00]"}`;

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors ${transparent ? "bg-transparent" : "bg-white/90 backdrop-blur border-b border-[#E5E7EB]"}`}
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline">
          <span
            className="text-xl font-black uppercase tracking-[0.04em]"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            <span className="text-black">K</span>
            <span style={{ color: "#FF6A00" }}>N</span>
            <span className={transparent ? "text-white" : "text-[#2B2B2B]"}>OVAS</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/catalogue" data-testid="nav-catalogue" className={linkClass}>Catalogue</NavLink>
          <NavLink to="/series/hinges" data-testid="nav-hinges" className={linkClass}>Hinges</NavLink>
          <NavLink to="/series/nsb-slim-box" data-testid="nav-nsb" className={linkClass}>NSB Slim</NavLink>
          <NavLink to="/about" data-testid="nav-about" className={linkClass}>About</NavLink>
          <NavLink to="/contact" data-testid="nav-contact" className={linkClass}>Contact</NavLink>
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="https://instagram.com/knovas_trading"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-instagram"
            className={`${transparent ? "text-white/80 hover:text-white" : "text-[#2B2B2B] hover:text-[#FF6A00]"} transition-colors`}
            aria-label="Instagram"
          >
            <Instagram size={18} />
          </a>
          <a
            href="https://www.facebook.com/share/1F9H6JGAZC/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-facebook"
            className={`${transparent ? "text-white/80 hover:text-white" : "text-[#2B2B2B] hover:text-[#FF6A00]"} transition-colors`}
            aria-label="Facebook"
          >
            <Facebook size={18} />
          </a>
          <a
            href="mailto:knovastrading@gmail.com"
            data-testid="nav-email"
            className={`${transparent ? "text-white/80 hover:text-white" : "text-[#2B2B2B] hover:text-[#FF6A00]"} transition-colors`}
            aria-label="Email"
          >
            <Mail size={18} />
          </a>
        </div>
      </div>
    </header>
  );
}
